import { reactive } from 'vue';
import i18n from '../../../../i18n';
import { createLoading } from '../../../../utils/loading';
import {
    createManageExportCsv,
    createManageSelect,
    createPage
} from '../../../../utils/page';
import {
    createColumnDate,
    createColumnInput, createColumnSelect
} from '../../../../components/table/c-table.logic';
import store from '../../../../store';
import { callCompanyByNameTh } from '../../company/company-doc-reject/company-doc-reject.section';
import { callAquaticType, callProductConsumption, callProductType } from '../../master-mgt/product/product.logic';
import { callLookupByGroupName } from '../../master-mgt/lab/product-grouping/product-grouping.logic';

export const callSearchSamplingProductAnalysisInput = ({ criteria }) => store.dispatch(`resource/v1/transaction/samplingProductAnalysisTopic/search`, { criteria });

export const { isLoading, setIsLoading } = createLoading();

export const onSearch = ({ page, props }) => {
    setIsLoading(true);
    const { refLabTypeKey } = props;
    const { where = [] } = page;


    where.push({
        name: 'refTopicAnalysisStatus.key', type: 'String', operator: '=', value: 'Reject'
    });

    if (refLabTypeKey) {
        where.push(
            { name: 'refSamplingProductAnalysis.refDepartment.refLabType.key', type: 'String', operator: '=', value: refLabTypeKey },
            { name: 'refSamplingProductAnalysis.refSamplingProduct.refSamplingRequest.refSamplingRequestType.key', type: 'String', operator: 'in', value: ['L', 'S'] }
        );
    }

    window.onSearch?.({ page });

    return callSearchSamplingProductAnalysisInput({
        criteria: {
            ...page,
            where: [...where],
            data: []
        }
    })
        .then(page => {
            page.data.forEach(record => {
                record.realValueStr = record.inputs.filter(it => {
                    if (it != null && it.realValue != null) {
                        return it.realValue.toString();
                    }
                }).map(it => it.realValue.toString()).join(',');
            })
            state.page = { ...page };
        })
        .finally(() => setIsLoading(false));
};


export const createColumns = ({ props }) => {
    const { refLabTypeKey } = props;
    const columns = [
        createColumnDate({
            title: () => i18n.global.t('model.samplingRequest.samplingCollectDate'),
            dataIndex: 'refSamplingProductAnalysis.refSamplingProduct.refSamplingRequest.samplingCollectDate',
            format: 'DD/MM/YYYY',
            align: 'center'
        }),
        createColumnInput({
            title: () => i18n.global.t('model.samplingProduct.samplingNo'),
            dataIndex: 'refSamplingProductAnalysis.refSamplingProduct.samplingNo',
            align: 'center'
        }),
        createColumnInput({
            title: () => i18n.global.t('views.report.labMicro.rejectTopicReport.productName'),
            dataIndex: 'refSamplingProductAnalysis.refSamplingProduct.refCompanyProduct.refProduct.nameTh',
            align: 'center'
        }),
        createColumnSelect({
            title: () => i18n.global.t('views.report.labMicro.rejectTopicReport.department'),
            dataIndex: 'refSamplingProductAnalysis.refDepartment.nameTh',
            align: 'center',
            inputProp: () => {
                return {
                    list: ({ searchQuery }) => store.dispatch('resource/v1/master/department/cacheFindAll', {
                        searchQuery,
                        where: [{ name: 'refLabType.key', type: 'String', operator: '=', value: refLabTypeKey }]
                    }),
                    optLabel: 'nameTh'
                };
            },
            search: { name: 'refDepartment.id' }
        }),
        createColumnSelect({
            visible: () => false,
            title: () => i18n.global.t('model.samplingProductAnalysisTopic.refTopicAnalysisStatus'),
            dataIndex: 'refTopicAnalysisStatus.value',
            align: 'center',
            inputProp: () => {
                return {
                    list: ({ searchQuery }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', {
                        group: 'ACCEPT_STATUS',
                        value: searchQuery
                    }).then(list => list.filter(it => it.key != 'RejectCanRepeat')),
                    optLabel: 'value'
                };
            },
            search: { name: 'refTopicAnalysisStatus.id', visible: () => false }
        }),
        createColumnSelect({
            visible: () => true,
            title: () => i18n.global.t('views.report.labMicro.rejectTopicReport.company'),
            dataIndex: 'refSamplingProductAnalysis.refSamplingProduct.refSamplingRequest.refCompany.nameTh',
            align: 'center',
            inputProp: () => {
                return {
                    list: callCompanyByNameTh,
                    optLabel: 'nameTh'
                };
            },
            search: { name: 'refSamplingProductAnalysis.refSamplingProduct.refSamplingRequest.refCompany.id' }
        }),
        createColumnSelect({
            dataIndex: 'refSamplingProductAnalysis.refSamplingProduct.refCountry1.nameEn',
            colProp: () => ({ xs: 24, md: 8 }),
            title: () => i18n.global.t('model.samplingProduct.refCountry1'),
            inputProp: () => ({
                list: ({ searchQuery }) => store.dispatch('resource/v1/master/country/cacheFindAll', {
                    nameTh: searchQuery,
                    nameEn: searchQuery
                }),
                optLabel: 'nameEn'
            }),
            search: { name: 'refSamplingProductAnalysis.refSamplingProduct.refCountry1.id' },
            align: 'center'
        }),
        createColumnSelect({
            dataIndex: `refSamplingProductAnalysis.refSamplingProduct.refCountry2.nameEn`,
            title: () => i18n.global.t('model.samplingProduct.refCountry2'),
            inputProp: () => ({
                list: ({ searchQuery }) => store.dispatch('resource/v1/master/country/cacheFindAll', {
                    nameTh: searchQuery,
                    nameEn: searchQuery
                }),
                optLabel: 'nameEn'
            }),
            search: { name: 'refSamplingProductAnalysis.refSamplingProduct.refCountry2.id' },
            align: 'center'
        }),
        createColumnSelect({
            title: () => i18n.global.t('model.product.refProductType'),
            dataIndex: 'refSamplingProductAnalysis.refSamplingProduct.refCompanyProduct.refProduct.refProductType.value',
            inputProp: () => ({
                list: callProductType,
                renderLabel: ({ item }) => (
                    <div>
                        {item.value}
                    </div>
                )
            }),
            search: {
                name: 'refProductType.id'
            },
            align: 'center'
        }),
        createColumnSelect({
            title: () => i18n.global.t('model.product.refAquaticType'),
            dataIndex: 'refSamplingProductAnalysis.refSamplingProduct.refCompanyProduct.refProduct.refAquaticType.value',
            inputProp: ({ field }) => {
                const aquaticSpeciesField = field.columns.find(d => d.dataIndex === 'refAquaticSpecies.value')?.search?.field;
                return {
                    list: callAquaticType,
                    renderLabel: ({ item }) => (
                        <div>
                            {item.value}
                        </div>
                    ),
                    'onUpdate:value': value => {
                        field.searchValue = value;
                        if (aquaticSpeciesField) {
                            aquaticSpeciesField.searchValue = null;
                        }
                    }
                };
            },
            search: {
                name: 'refAquaticType.id'
            },
            align: 'center'
        }),
        createColumnSelect({
            visible: () => props.refLabTypeKey == 'labChemi',
            title: () => i18n.global.t("model.product.refAquaticSource"),
            dataIndex: "refSamplingProductAnalysis.refSamplingProduct.refCompanyProduct.refProduct.refAquaticSource.value",
            inputProp: ({ field }) => {
                return {
                    value: field.searchValue,
                    "onUpdate:value": value => (field.searchValue = value),
                    list: ({ searchQuery }) => callLookupByGroupName({ group: "AQUATIC_SOURCE", searchQuery }),
                    optLabel: "value"
                };
            },
            search: {
                name: 'refSamplingProductAnalysis.refSamplingProduct.refCompanyProduct.refProduct.refAquaticSource.id',
                visible: () => props.refLabTypeKey == 'labChemi',
            },
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t('model.product.refProductConsumption'),
            dataIndex: 'refSamplingProductAnalysis.refSamplingProduct.refCompanyProduct.refProduct.refProductConsumption.value',
            inputProp: () => ({
                list: callProductConsumption,
                renderLabel: ({ item }) => (
                    <div>
                        {item.value}
                    </div>
                )
            }),
            search: {
                name: 'refProductConsumption.id'
            },
            align: 'center'
        }),
        createColumnSelect({
            title: () => i18n.global.t('model.topic.modelName'),
            dataIndex: 'refLabTopic.nameS',
            inputProp:  () => ({
                list: ({ searchQuery }) => store.dispatch('resource/v1/master/labTopic/cacheFindAll', { searchQuery, labTypeKey: refLabTypeKey }),
                optLabel: "nameS"
            }),
            search: { name: 'refLabTopic.id' },
            align: "center",
        }),
        // createColumnInput({
        //     title: () => i18n.global.t('views.report.labMicro.rejectTopicReport.analysisResult'),
        //     dataIndex: 'realValue',
        //     align: 'center',
        //     customRender: ({ record }) => {
        //         const realValueStrs = record.inputs.filter(it => {
        //             if (it != null && it.realValue != null) {
        //                 return it.realValue.toString();
        //             }
        //         }).map(it => it.realValue.toString()).join(',');
        //         return <div>{realValueStrs}</div>;
        //     },
        //     search: { visible: () => false },
        // }),
        createColumnInput({
            title: () => i18n.global.t('views.report.labMicro.rejectTopicReport.analysisResult'),
            dataIndex: 'realValueStr',
            align: 'center',
            search: { visible: () => false },
        })
    ];
    return columns;
};

export const state = reactive({
    columns: [],
    page: createPage({
        options: {
            select: [
                '**',
                'refCreateBy.fullName',
                'refSamplingProductAnalysis.refDepartment.*',
                'refSamplingProductAnalysis.refSamplingProduct.refSamplingRequest.*',
                'refSamplingProductAnalysis.refSamplingProduct.refCompanyProduct.refProduct.*',
                'refSamplingProductAnalysis.refSamplingProduct.refCompanyProduct.refProduct.refProductType.*',
                'refSamplingProductAnalysis.refSamplingProduct.refCompanyProduct.refProduct.refAquaticType.*',
                'refSamplingProductAnalysis.refSamplingProduct.refCompanyProduct.refProduct.refAquaticSource.*',
                'refSamplingProductAnalysis.refSamplingProduct.refCompanyProduct.refProduct.refProductConsumption.*',
                'refSamplingProductAnalysis.refSamplingProduct.refSamplingRequest.refCompany.*',
                'refSamplingProductAnalysis.refSamplingProduct.refSamplingRequest.refCountry1.*',
                'refSamplingProductAnalysis.refSamplingProduct.refSamplingRequest.refCountry2.*'
            ],
            children: [{
                page: 0, size: 100,
                name: 'inputs',
                select: ['**']
            }],
            page: 0,
            size: 100000000
        }
    }),
    tableOptions: { search: { activeKey: 'Search' } }
});

export const initState = ({ props, data }) => {
    const menuContext = props.menuContext;
    state.columns = createColumns({ props, data });
    state.manages = [
        createManageSelect({ menuContext }),
        createManageExportCsv({ menuContext })
    ];
    state.manageExtras = [];
};


